<template>
  <div>
    <PageHeader title="サブタスクマスタ" class="list">
      <template #title-header-content>
        <div class="ml-auto">
          <PrimaryButton text="新規" size="normal hover:bg-pink-400" class="new" @click="edit({})"/>
        </div>
      </template>
    </PageHeader>
    <main class="absolute top-20 w-screen bottom-4 -mt-2 leading-8 list">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <table class="table">
            <thead class="th sticky top-0">
              <tr class="column">
                <th class="th2 text-green-700">カテゴリー</th>
                <th class="th2">サブタスク</th>
                <th class="th2 text-blue-700">詳細<div class="text-black">メモ</div></th>
                <th class="th2">担当部署<br>担当者</th>
                <th class="th2">期限<br><pre>最終完了</pre></th>
                <th class=""></th>
                <th class=""></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in list" :key="index" :class="setColor(index)" class="hover-color text-sm">
                <!-- カテゴリ -->
                <td class="p-2 text-green-700 text-xs whitespace-pre-line">
                  {{ row.category?row.category.join('\r\n'):'' }}
                </td>
                <!-- サブタスク -->
                <td class="p-2 text-gray-700 font-bold">
                  {{ row.name }}
                </td>
                <!-- 詳細/メモ -->
                <td class="p-2 whitespace-pre-line text-blue-600">
                  <!-- 詳細 -->
                  <div><pre>{{getDetails(row)}}</pre></div>
                  <!-- メモ -->
                  <div v-if="row.memo" class="text-xs text-gray-700"><pre>{{row.memo}}</pre></div>
                </td>
                <!-- 担当部署・担当者 -->
                <td class="p-2">
                  <!-- 部署 -->
                  <div v-if="row.byMainDepartment">
                    <div class="text-xs text-gray-500 mb-2">メイン依頼先部署 ➡ サブ担当部署</div>
                    <div v-for="(ch, i) in row.charge" :key="'charge'+i" class="text-xs mb-2">
                      <pre>{{ ch.mainDepartmentName }} ➡ {{ ch.departmentName }}</pre>
                      <pre>{{ ch.toStaffName }}</pre>
                    </div>
                  </div>
                  <div v-else>
                    <pre>{{ row.departmentName }}</pre>
                    <pre>{{ row.toStaffName }}</pre>
                  </div>
                </td>
                <!-- 期限 -->
                <td class="p-2">
                  <div v-if="row.limit">
                    <pre><span v-if="row.limitTarget">{{limitTarget(row.limitTarget)}}</span>{{row.limit}}<span> {{row.limitMonthCount?' ヶ月後': ' 日後'}}</span></pre>
                  </div>
                  <div v-else class="text-gray-700 text-xs">期限初期設定なし</div>

                  <!-- 最終完了タスク -->
                  <div class="font-bold mt-1 text-blue-800">{{ row.finalCompletionTask ? '✔最終完了タスク' : '' }}</div>
                </td>
                
                <td class="td1 py-2"><PrimaryButton text="編集" @click="edit(row)" /></td>
                <td class="td1"><PrimaryButton text="削除" @click="deleteData(row)" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
    <!-- 編集・新規登録モーダル -->
    <SubTaskMasterEditModal 
      v-model="modalShow"
      :target="editData"
      :subList="list"
      :open="modalShow"
      @modalClose="modalClose"
    />
  </div>
</template>
<script>

import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SubTaskMasterEditModal from '../components/SubTaskMasterEditModal.vue'
import * as taskRequestManager from '@managers/taskRequestManager'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import { SUB_TASK_LIMIT } from '@libs/constants'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    PrimaryButton,
    PageHeader,
    SubTaskMasterEditModal
  },

  data() {
    return {
      // サブタスク
      list: [],
      // モーダル表示
      modalShow: false,
      // 編集する内容
      editData: {},
    }
  },

  async created() {
    await this.getData()
  },

  computed: {
    /**
     * 詳細の表示
     */
    getDetails() {
      return (row) => {
        if (row.details && row.details.length) {
          const res = row.details.map((d) => {
            return d.task
          })
          return res.join('\r\n')
        }
        return null
      }
    },

    /**
     * 期限のもととなる日
     */
    limitTarget() {
      return (val) => {
        const res = SUB_TASK_LIMIT.find((l) => {
          return l.value == val
        })
        if (res && res.name) {
          return res.name + ' から '
        }
        return ''
      }
    }
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      this.list = []
      let res = await taskRequestManager.getTaskMst(this)
      if (res && res.length > 0) {
        this.list = res
      } else if (res.error) {
        alert(res.msg)
      }
    },

    /**
     * 編集イベント
     * @param data 編集内容
     */
    edit(data) {
      this.modalShow = true
      this.editData = data
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      }
    },

    /**
     * モーダルを閉じる
     */
    async modalClose() {
      this.modalShow = false
      await this.getData()
    },

    /**
     * 削除イベント
     * @param row 削除するデータ
     */
    async deleteData(row) {
      const dialogResult = await dialogs.showWarningConfirmDialog('削除', '削除してよろしいですか？')
      if (dialogResult === 'YES') {
        let registApp = await this.$pigeon.deleteTask(row._id)
        if (!registApp) {
          await dialogs.showErrorDialog('エラー', '削除できませんでした。')
          return
        }
        logManager.recording(this, logManager.Loglevel.INFO, 'サブタスクマスタ', '削除', 'サブタス（' + row.task + '）を削除しました。')
        await this.getData()
      }
    }
  }
}
</script>

<style scoped>
.table {
  width: 100%;
}

.column th {
  height: 50px;
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}

.th2 {
  text-align: left;
  padding-left: 10px;
}

.td1 {
  text-align: center;
}

.new {
  width: 200px;
  background: #eb94c8;
}

.hover-color:hover {
  background-color: rgba(198, 233, 239, 0.853);
}

@media screen and (max-width: 1400px) {
  .list {
    min-width: 1400px !important;
  }
}
</style>